import React, { useState } from 'react';
import { MailIcon, Loader2Icon, SparklesIcon, CopyIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function EmailFunnelSequence() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const [sequenceType, setSequenceType] = useState('welcome');
  const [expandedEmail, setExpandedEmail] = useState<number | null>(1);
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 3000);
  };
  const emails = [{
    id: 1,
    day: 'Día 0 (Inmediato)',
    subject: '🍰 Tu Guía Porción-Rentable está aquí adentro',
    preview: 'Bienvenida oficial + Enlace de acceso',
    body: '¡Hola [Nombre]!\n\nQué emoción tenerte aquí. Acabas de dar el primer paso para dejar de regalar tu trabajo y empezar a construir un negocio de postres verdaderamente rentable.\n\nAquí tienes el enlace de acceso inmediato a tu guía:\n👉 [ENLACE DE ACCESO]\n\nMi recomendación: no intentes leer todo de una vez. Ve directo a la página 12 y usa la calculadora de costos con tu postre más vendido. Te vas a sorprender.\n\nMañana te escribiré para contarte el error #1 que casi me hace quebrar mi negocio (y cómo evitarlo).\n\nUn abrazo,\n[Tu Nombre]'
  }, {
    id: 2,
    day: 'Día 1',
    subject: 'El error que me costó $500 dólares en mi primer mes 🤦‍♀️',
    preview: 'Por qué calcular "al ojo" te está arruinando',
    body: '¡Hola [Nombre]!\n\n¿Alguna vez has pensado "si el pastel de la panadería cuesta $20, yo lo vendo a $18 porque es casero"?\n\nEse fue mi error exacto.\n\nTerminé trabajando 14 horas diarias, cansada, y cuando hice cuentas... había perdido dinero. Estaba pagando por trabajar.\n\nEn el capítulo 2 de tu guía te explico por qué el valor "casero" debería ser MÁS caro, no más barato. Y cómo comunicarlo a tus clientes sin que se asusten.\n\n¿Ya hiciste el ejercicio de la página 12 que te pedí ayer? Responde a este correo y cuéntame qué descubriste.\n\nSeguimos,\n[Tu Nombre]'
  }, {
    id: 3,
    day: 'Día 3',
    subject: '¿Lista para el siguiente nivel? 🚀',
    preview: 'Upsell: Plantillas de Excel Automatizadas',
    body: '¡Hola [Nombre]!\n\nA estas alturas ya debes haber entendido la importancia de costear cada gramo de tus ingredientes.\n\nPero sé que hacer las matemáticas a mano puede ser tedioso.\n\nPor eso creé el "Pack de Calculadoras Automáticas en Excel". Solo metes el precio de tus ingredientes en el supermercado, y la tabla te dice exactamente a cuánto vender la porción, la docena o el pastel entero.\n\nComo ya eres alumna de la guía, tienes un 50% de descuento solo por las próximas 48 horas.\n\n👉 [ENLACE AL UPSELL CON DESCUENTO]\n\nNo más matemáticas aburridas. Solo cocinar y ganar.\n\nNos vemos dentro,\n[Tu Nombre]'
  }];
  return <div className="max-w-5xl mx-auto space-y-8 animate-in fade-in duration-500" data-id="element-274">
      <div data-id="element-275">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-276">
          Secuencia de Emails
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-277">
          Genera funnels de email automatizados para nutrir, vender y recuperar
          carritos.
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-278">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-279">
          <div className="space-y-2" data-id="element-280">
            <label className="block text-sm font-medium text-slate-700" data-id="element-281">
              Tipo de Secuencia
            </label>
            <select value={sequenceType} onChange={e => setSequenceType(e.target.value)} className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-282">
              <option value="welcome" data-id="element-283">Bienvenida + Upsell (Post-compra)</option>
              <option value="abandoned" data-id="element-284">
                Recuperación de Carrito Abandonado
              </option>
              <option value="launch" data-id="element-285">Lanzamiento de Nuevo Producto</option>
              <option value="reactivation" data-id="element-286">Reactivación de Lista Fría</option>
            </select>
          </div>

          <div className="space-y-2" data-id="element-287">
            <label className="block text-sm font-medium text-slate-700" data-id="element-288">
              Cantidad de Emails
            </label>
            <select className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-289">
              <option value="3" data-id="element-290">3 Emails (Corta)</option>
              <option value="5" data-id="element-291">5 Emails (Estándar)</option>
              <option value="7" data-id="element-292">7 Emails (Larga)</option>
            </select>
          </div>

          <div className="space-y-2" data-id="element-293">
            <label className="block text-sm font-medium text-slate-700" data-id="element-294">
              Tono Principal
            </label>
            <select className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-295">
              <option value="storytelling" data-id="element-296">
                Storytelling (Historias personales)
              </option>
              <option value="direct" data-id="element-297">Directo al grano (Venta dura)</option>
              <option value="educational" data-id="element-298">Educativo / Valor primero</option>
            </select>
          </div>
        </div>

        <div className="mt-8 flex justify-end pt-6 border-t border-slate-100" data-id="element-299">
          <button onClick={handleGenerate} disabled={isGenerating} className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-xl font-medium flex items-center gap-2 disabled:opacity-50 transition-colors" data-id="element-300">
            {isGenerating ? <>
                <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-301" /> Escribiendo
                Secuencia...
              </> : <>
                <SparklesIcon className="w-5 h-5" data-id="element-302" /> Generar Funnel de Emails
              </>}
          </button>
        </div>
      </div>

      {hasGenerated && <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500" data-id="element-303">
          <div className="flex items-center justify-between" data-id="element-304">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-305">
              Secuencia Generada: Bienvenida + Upsell
            </h2>
            <button className="text-indigo-600 hover:text-indigo-800 font-medium text-sm flex items-center gap-1" data-id="element-306">
              <CopyIcon className="w-4 h-4" data-id="element-307" /> Copiar Toda la Secuencia
            </button>
          </div>

          <div className="relative border-l-2 border-indigo-100 ml-4 space-y-6 pb-4" data-id="element-308">
            {emails.map(email => <div key={email.id} className="relative pl-8" data-id="element-309">
                <div className="absolute -left-[11px] top-4 w-5 h-5 rounded-full bg-indigo-500 border-4 border-white shadow-sm" data-id="element-310"></div>

                <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-311">
                  <button onClick={() => setExpandedEmail(expandedEmail === email.id ? null : email.id)} className="w-full text-left bg-slate-50 p-4 flex items-center justify-between hover:bg-slate-100 transition-colors" data-id="element-312">
                    <div data-id="element-313">
                      <span className="text-xs font-bold text-indigo-600 uppercase tracking-wider" data-id="element-314">
                        {email.day}
                      </span>
                      <h3 className="font-bold text-slate-900 mt-1 text-lg" data-id="element-315">
                        {email.subject}
                      </h3>
                      <p className="text-sm text-slate-500 mt-0.5" data-id="element-316">
                        Preview: {email.preview}
                      </p>
                    </div>
                    {expandedEmail === email.id ? <ChevronUpIcon className="w-5 h-5 text-slate-400" data-id="element-317" /> : <ChevronDownIcon className="w-5 h-5 text-slate-400" data-id="element-318" />}
                  </button>

                  {expandedEmail === email.id && <div className="p-6 border-t border-slate-200 relative" data-id="element-319">
                      <button className="absolute top-4 right-4 text-slate-400 hover:text-indigo-600 transition-colors" title="Copiar este email" data-id="element-320">
                        <CopyIcon className="w-4 h-4" data-id="element-321" />
                      </button>
                      <div className="prose prose-sm max-w-none prose-p:text-slate-700 whitespace-pre-wrap font-sans" data-id="element-322">
                        {email.body}
                      </div>
                    </div>}
                </div>
              </div>)}
          </div>
        </div>}
    </div>;
}